<template>
    <div
    class="modal right fade trader-info"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div style="max-width: 1500px;" class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Configure Swap</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="section-label text-left ">Highest Bids</div>

            <!-- <div class="text-left mb-1 mt-3" style="font-size: 18px; font-weight: bold;">
                Highest Bids
            </div> -->
            <!-- Selected BidWanteds Display -->

            <div class="bid-cards-row">
                <!-- Card 1 -->
                <div class="bid-card" v-for="(value) in selectedBidWanteds" :key="value.id">
                    <div class="bid-card-top">
                    <span class="bc-cusip">{{ value.cusipVal }}</span>
                    <span class="bc-qty">{{ value.sellQuantity }}</span>
                    <span class="bc-price">${{ value.highestBids[0].bidPrice }}</span>
                    </div>
                    <input class="spread-input" type="number" placeholder="Enter Spread" v-model.number="value.spread" />
                </div>
            </div>
            <form @submit.prevent="">
                <!-- Input Section -->
                <div class="row row-cols-auto g-2 align-items-end">
                <div class="col-md-4 text-left">
                    <label>CUSIP *</label>
                    <input type="text"  maxlength="9" class="form-control form-control-sm" placeholder="Enter Cusip" v-model="cusip" />
                </div>             
                <div class="col-md-4 text-left">
                    <label>Quantity *</label>
                    <input type="number" step="any"  class="form-control form-control-sm" placeholder="Quantity" v-model.number="quantity" />
                </div>
                 <div class="col-md-3 text-left">
                    <label>Price *</label>
                    <input type="number" step="any" class="form-control form-control-sm" placeholder="Price" v-model.number="price" />
                </div>
                <div class="col text-right">
                    <button @click="addCusip()" type="button" class="btn btn-sm btn-warning mr-4">Add</button>
                </div>
                </div>

                <!-- Table Section -->
                <div class="table-responsive pl-2">
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                    <thead class="thead-light">
                    <tr>
                        <th class="text-left">CUSIP</th>
                        <th class="text-left">Quantity</th>
                        <th class="text-left">Price</th>
                        <th class="text-left" style="width: 100px;">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-if="bidWantedSwapCusipBuyList.length == 0">
                          <td><p class="nodata">No CUSIP added. Please add a CUSIP to get the swap summary</p>
                          </td>
                      </tr>
                    <tr v-for="(item, index) in bidWantedSwapCusipBuyList" :key="index">
                        <td > <input @change="onDataChange()" type="text" v-model="item.cusip" style="max-width: 300px;" class="form-control form-control-sm" /></td>
                        <td><input @change="onDataChange()" step="any"  type="number" v-model.number="item.quantity" class="form-control form-control-sm" /></td>
                        <td><input @change="onDataChange()" step="any"  type="number" v-model.number="item.price" class="form-control form-control-sm" /></td>
                        <td>
                        <button class="btn btn-danger btn-sm" @click="deleteItem(index)">Delete</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>

                <!-- Other Fields -->
                <div class="row row-cols-auto g-2 align-items-end">
                <!-- <div class="col">
                    <label>Spread on Sell</label>
                    <input type="number" class="form-control form-control-sm" placeholder="Spread" v-model.number="spread" />
                </div> -->
                <div class="col">
                    <label>Settlement Date</label>
                    <DatePicker
                    :disabledDates="disabledDatesSettlement"
                    v-model="settlementDate"
                    placeholder="mm/dd/yyyy"
                    typeable
                    name="settlementDate"
                    format="MM/dd/yyyy"
                    :clear-button="false"
                    :calendar-button="true"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                    />
                </div>
                
                <div class="col text-right">
                    <button :disabled="bidWantedSwapCusipBuyList.length == 0" @click="showSwapSummary()" type="button" class="btn btn-success btn-sm">Show Swap Summary</button>
                    <button :disabled="swapResultBuy.length == 0" @click="showExportModal()" type="button" class="btn btn-info mr-3 btn-sm ">Export</button>
                </div>
                </div>
                 <div class="row pl-2 mt-1">
                    <div class="table-responsive" v-if="swapResultSell.length > 0">
                        <!-- Account Header -->
                        <div class="account-header">
                            <span class="name">{{swapResult.customer}}</span>
                            <span class="id">{{swapResult.accountString}}</span>
                        </div>
                          <!-- SELL TABLE -->
                        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                            <thead class="thead-light">
                            <tr class="section-header">
                                <th class="text-left">Sell</th>
                                <th class="text-left">Bond</th>
                                <th class="text-left">Cusip</th>
                                <th class="text-right">Coupon</th>
                                <th class="text-left">Maturity Date</th>
                                <th class="text-left">Call Date</th>
                                <th class="text-left">Insured</th>
                                <th class="text-left">S&amp;P Rating</th>
                                <th class="text-left">Cost</th>
                                <th class="text-left">Cost YTM</th>
                                <th class="text-left">Cost YTC</th>
                                <th class="text-left">Date Bought</th>
                                <th class="text-left">Income</th>
                                <th class="text-left">Proceeds</th>
                                <th class="text-left">Gain/Loss</th>
                                <th class="text-left">Price</th>
                                <th class="text-left">YTM</th>
                                <th class="text-left">YTC</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- Data row -->
                             <tr v-for="(item, index) in swapResultSell" :key="'sell-' + index">
                                <td class="qty">{{ item.quantity }}</td>
                                <td class="text-left">{{ item.cusipDescription }}</td>
                                <td class="text-left">{{ item.cusip }}</td>
                                <td class="text-right">{{ item.coupon }}%</td>
                                <td class="text-left">{{ item.maturityDate }}</td>
                                <td class="text-left">{{ item.callDate }}</td>
                                <td class="text-left">{{ item.insurance }}</td>
                                <td class="text-left">{{ item.ratingSp }}</td>
                                <td class="text-right"><span :class="{ 'text-danger': item.averageCost < 0 }">{{ item.averageCost | currency }}</span></td>
                                <td class="text-right">{{ item.costYtm }}%</td>
                                <td class="text-right">{{ item.costYtc }}%</td>
                                <td class="text-left">{{ item.boughtDateString }}</td>
                                <td class="text-right"> <span :class="{ 'text-danger': item.income < 0 }">{{ item.income | currency }}</span></td>
                                <td class="text-right"> <span :class="{ 'text-danger': item.proceeds < 0 }">{{ item.proceeds | currency }}</span></td>
                                <td class="text-right"><span :class="{ 'text-danger': item.gainLoss < 0 }">{{ item.gainLoss | currency }}</span></td>
                                <td class="text-right"> <span :class="{ 'text-danger': item.price < 0 }">{{ item.price | currency }}</span></td>
                                <td class="text-right">{{ item.ytm }}%</td>
                                <td class="text-right">{{ item.ytc }}%</td>
                                </tr>
                            <!-- <tr>
                                <td class="qty">10</td>
                                <td>Safeway Inc.</td>
                                <td>786514AS8</td>
                                <td class="text-right">7.450%</td>
                                <td class="text-right">09/15/2027</td>
                                <td></td>
                                <td></td>
                                <td>BB+</td>
                                <td class="text-right">$ &nbsp;&nbsp;97.54</td>
                                <td class="text-right">9.28%</td>
                                <td class="text-right">0.00%</td>
                                <td class="text-right">08/22/2018</td>
                                <td class="text-right">$ &nbsp;&nbsp;745.00</td>
                                <td class="text-right">$ &nbsp;10,256.70</td>
                                <td class="text-right">$ &nbsp;&nbsp;502.70</td>
                                <td class="text-right">$ &nbsp;102.57</td>
                                <td class="text-right">5.60%</td>
                                <td></td>
                            </tr> -->
                            <!-- Cash in account row -->
                            <tr class="cash-row">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td ></td>
                                <td style="text-align:right; font-weight:600;"> <span v-if="swapResult.totalCashInAccount !== 0">Cash in account</span></td>
                                <td class="text-right"><span v-if="swapResult.totalCashInAccount !== 0" :class="{ 'text-danger': swapResult.totalCashInAccount < 0 }">{{swapResult.totalCashInAccount | currency}}</span></td>
                                <td ></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- Total row -->
                            <tr class="total-row">
                                <td class="qty">{{swapResult.totalSellQuantity}}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">Total</td>
                                <td class="text-right"> <span :class="{ 'text-danger': swapResult.totalSellIncome < 0 }">{{swapResult.totalSellIncome | currency}}</span></td>
                                <td class="text-right"> <span :class="{ 'text-danger': swapResult.totalSellCash < 0 }">{{swapResult.totalSellCash | currency}}</span></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- <div class="section-spacer"></div> -->
                    </div>
                    <div class="table-responsive" v-if="swapResultBuy.length > 0">
                        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                            <thead class="thead-light">
                            <tr class="section-header">
                                <th class="text-left">Buy</th>
                                <th class="text-left">Bond</th>
                                <th class="text-left">Cusip</th>
                                <th class="text-right">Coupon</th>
                                <th class="text-left">Maturity Date</th>
                                <th class="text-left">Call Date</th>
                                <th class="text-left">Insured</th>
                                <th class="text-left">S&amp;P Rating</th>
                                <th style="width: 50px;" class="empty-col">&nbsp;</th>
                                <th style="width: 50px;" class="empty-col">&nbsp;</th>
                                <th style="width: 50px;" class="empty-col">&nbsp;</th>
                                <th style="width: 50px;" class="empty-col">&nbsp;</th>
                                <th class="text-left">Income</th>
                                <th class="text-left">Proceeds</th>
                                <th style="width: 50px;" class="empty-col">&nbsp;</th>
                                <th class="text-left">Price</th>
                                <th class="text-left">YTM</th>
                                <th class="text-left">YTC</th>
                            </tr>
                            </thead>
                            <tbody v-for="(item, index) in swapResultBuy" :key="'buy-' + index">
                            <!-- Data row -->
                                
                                <tr >
                                    <td class="qty">{{ item.quantity }}</td>
                                    <td class="text-left">{{ item.cusipDescription }}</td>
                                    <td class="text-left">{{ item.cusip }}</td>
                                    <td class="text-right">{{ item.coupon }}%</td>
                                    <td class="text-left">{{ item.maturityDate }}</td>
                                    <td class="text-left">{{ item.callDate }}</td>
                                    <td class="text-left">{{ item.insurance }}</td>
                                    <td class="text-left">{{ item.ratingSp }}</td>
                                    <td class="text-right empty-col">&nbsp;</td>
                                    <td class="text-right empty-col">&nbsp;</td>
                                    <td class="text-right empty-col">&nbsp;</td>
                                    <td class="text-right empty-col">&nbsp;</td>
                                    <td class="text-right"> <span :class="{ 'text-danger': item.income < 0 }">{{ item.income | currency }}</span></td>
                                    <td class="text-right"> <span :class="{ 'text-danger': item.proceeds < 0 }">{{ item.proceeds | currency }}</span></td>
                                    <td class="text-right empty-col">&nbsp;</td>
                                    <td class="text-right"> <span :class="{ 'text-danger': item.price < 0 }">{{ item.price | currency }}</span></td>
                                    <td class="text-right">{{ item.ytm }}%</td>
                                    <td class="text-right">{{ item.ytc }}%</td>
                                    </tr>
                                <!-- Cash leftover row -->
                                <tr class="cash-row">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style="text-align:right; font-weight:600;">Cash leftover</td>
                                    <td class="text-right" > <span :class="{ 'text-danger': item.cashLeftOver < 0 }">{{item.cashLeftOver | currency }}</span></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                         
                            </tbody>
                        </table>

                    </div>
                </div>
               
            </form>
        </div>
        </div>
    </div>
     <div
        class="modal fade"
        id="exportmodal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Export</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form @submit.prevent="">
                <div class="form-group">
                    <label for="attributesList">Attributes</label>
                    <!-- <p class="text-muted">Add attributes to be included in the export</p> -->
                    <div class="input-group mb-2">
                        <input
                            type="text"
                            id="newAttribute"
                            v-model="newAttribute"
                            class="form-control"
                            placeholder="Type an attribute, then press Add for the next one"

                        />
                        <div class="input-group-append" style="height: 39px;">
                            <button type="button" class="btn btn-primary" @click="addAttribute">Add</button>
                        </div>
                    </div>
                </div>
                    <div class="form-group mt-4">
                        <ul class="list-group">
                            <li v-for="(attribute, index) in attributesList" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
                                {{ attribute }}
                                <button type="button" class="btn btn-danger btn-sm" @click="attributesList.splice(index, 1)">Delete</button>
                            </li>
                        </ul>
                    </div>
                    <div class="form-group mt-4">
                        <label for="exportType">Export Type</label>
                        <select id="exportType" v-model="exportType" class="form-control">
                            <option value="pdf">PDF</option>
                            <option value="excel">Excel</option>
                        </select>
                    </div>

                    <div class="modal-footer mt-4">
                        <button :disabled="isExporting" type="button" class="btn btn-success" @click="exportData">
                            {{ isExporting ? 'Exporting...' : 'Export' }}
                        </button>
                    </div>
                </form>
            </div>
            </div>
        </div>
    </div>

    </div>
</template>

<script>
import config from "@/config";
import authService from "@/authService";
import DatePicker from 'vuejs-datepicker';

export default {
    name: 'swap',
    props:['selectedBidWanteds'],
    components :{
        DatePicker
    },
    data() {
        return {
            loading : false,
            disabledDatesSettlement: {
                to : this.getYestedayDate()
            },
            settlementDate: "",
            bidWantedSwapCusipBuyList : [],
            cusip : "",
            price : "",
            quantity : "",
            spread : "",
            swapResult : null,
            swapResultSell : [],
            swapResultBuy : [],
            attributesList : [],
            newAttribute: "",
            exportType: 'excel', // Default export type
            isExporting: false,
            userSwapCusipBuyList: [],
            cardColors: ['#e3f2fd', '#e8f0fe', '#e0f7e9', '#fff3e0'], // Colors for cards,
            swapHistoryFromLocalStorage: [],
        }

    },
    methods : {
        onDataChange(){
            this.setSwapHistoryToLocalStorage("savelocal");
        },
        addAttribute() {
            if (this.newAttribute.trim()) {
                this.attributesList.push(this.newAttribute.trim());
                this.newAttribute = "";
            }
        },
       showExportModal(){
            this.attributesList = [];
            this.newAttribute = "";
            this.exportType = 'excel'; // Reset to default
            this.isExporting = false;
            window.$('#exportmodal').modal("show");
            this.setSwapHistoryToLocalStorage("export");
        },
        deleteBuy(index) {
            const buyItems = this.swapResultBuy;
            const itemToDelete = buyItems[index];

            const actualIndex = this.swapResultBuy.findIndex(
                item => item === itemToDelete
            );

            if (actualIndex !== -1) {
                this.swapResultBuy.splice(actualIndex, 1);
            }
        },
        deleteSell(index) {
            const sellItems = this.swapResultSell;
            const itemToDelete = sellItems[index];

            const actualIndex = this.swapResultSell.findIndex(
                item => item === itemToDelete
            );

            if (actualIndex !== -1) {
                this.swapResultSell.splice(actualIndex, 1);
            }
        },
        deleteItem(index){
            this.bidWantedSwapCusipBuyList.splice(index,1)
            this.setSwapHistoryToLocalStorage("savelocal");
        },
        exportData(){
            if(this.newAttribute.trim()){
                this.addAttribute();
            }
            var self = this;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.isExporting = true;    
            var postData = {};
                postData.cognitoSub =  authService.getUser().cognitoSub
                postData.swapSellList = this.swapResultSell;
                postData.swapBuyList = this.swapResultBuy;
                postData.attributeList = this.attributesList;
                postData.formatType = this.exportType;
                postData.totalCashInAccount = this.swapResult.totalCashInAccount;
                postData.totalSellProceeds = this.swapResult.totalSellProceeds; 
                postData.totalSellCash = this.swapResult.totalSellCash;
                postData.totalSellQuantity = this.swapResult.totalSellQuantity;
                postData.customer = this.swapResult.customer;
                postData.accountString = this.swapResult.accountString;
                postData.totalSellIncome = this.swapResult.totalSellIncome;
            this.$http
            .post(
            config.baseUrlAutoBidder +
                "/bidwanted/swap-list-download",postData,
                auth
            )
            .then((result) => {
                this.isExporting = false;    
                window.open(result.data, "_blank");

            }).catch(error => {
                if(error.message.includes("504")){
                self.$fire({
                    title: "Download timed out",
                    type: 'warning',
                    html: 'Please check file logs to download the file.',
                    footer: '<a href="/bidaccumulator/file-logs?moduleName=ba">Click here to see the file logs</a>'
                })
                    // self.$alert("Download timed out. Please check file logs to download the file.","","warning")
                }
                self.isExporting = false;
                });
        },
        showSwapSummary(){
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;    

            var postData = {};
                // postData.bidWantedIds = this.selectedBidWanteds.map(item => item.id)
                postData.settlementDate = this.moment(this.settlementDate).format("MM/DD/YYYY")
                // postData.spread = this.spread;
                // postData.spread = this.selectedBidWanteds.map(item => item.spread || 0 ,);
                postData.bidWantedSwapSellList = this.selectedBidWanteds.map(item => {
                    return {
                        bidWantedId: item.id,
                        spread: item.spread || 0
                    };
                });
                postData.bidWantedSwapCusipBuyList = this.bidWantedSwapCusipBuyList.map(item => {
                    // const { createdAt, bidWantedId, ...rest } = item;
                    delete item.createdAt; // Remove createdAt if not needed
                    delete item.bidWantedId; // Remove bidWantedId if not needed
                    return item;
                });

            this.$http
            .post(
            config.baseUrlAutoBidder +
                "/bidwanted/swap-list",postData,
                auth
            )
            .then((result) => {
                this.loading = false;
                this.swapResult = result.data;
                this.swapResultSell = result.data.swapSellList || [];
                this.swapResultBuy = result.data.swapBuyList || [];
                // this.swapResult.totalIncome = result.data.swapSellList.reduce((total, item) => total + item.income, 0);
                this.setSwapHistoryToLocalStorage();

            }).catch(() => this.loading = false);
        },
        setSwapHistoryToLocalStorage(mode){
            const storageKey = authService.getUser().id + 'swapHistory';
            if (this.bidWantedSwapCusipBuyList.length > 0) {
                this.bidWantedSwapCusipBuyList.forEach(item => {
                    item.createdAt = this.moment().format("MM/DD/YYYY");
                    item.bidWantedId = this.selectedBidWanteds.map(bid => bid.id).join('-');
                });
            }
            const currentBidWantedId = this.selectedBidWanteds.map(bid => bid.id).join('-');
            this.swapHistoryFromLocalStorage = this.swapHistoryFromLocalStorage.filter(item => item.bidWantedId !== currentBidWantedId);
            this.swapHistoryFromLocalStorage.push(...this.bidWantedSwapCusipBuyList);
            if (mode === "export") {
                // Handle export mode
                let otherItems = this.swapHistoryFromLocalStorage.filter(item => item.bidWantedId !== currentBidWantedId);

                this.swapHistoryFromLocalStorage = this.swapHistoryFromLocalStorage.filter(
                    item => this.swapResultBuy.some(
                        buyItem => buyItem.cusip === item.cusip && buyItem.quantity === item.quantity
                    )
                );
                this.swapHistoryFromLocalStorage.push(...otherItems);
                localStorage.setItem(storageKey, JSON.stringify(this.swapHistoryFromLocalStorage));

            }else {
                localStorage.setItem(storageKey, JSON.stringify(this.swapHistoryFromLocalStorage));
            }
            if(mode !== "savelocal"){
                this.setSwapHistoryToDb();
            }
        },
         setSwapHistoryToDb(){
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            var postData = {};
                postData.userId = authService.getUser().id;
                postData.bidWantedId = this.selectedBidWanteds.map(bid => bid.id);
                postData.settlementDate = this.moment(this.settlementDate).format("MM/DD/YYYY")
                postData.spread = this.spread;
                // postData.bidWantedSwapCusipBuyList = this.bidWantedSwapCusipBuyList.map(item => {
                //     // const { createdAt, bidWantedId, ...rest } = item;
                //     delete item.createdAt; // Remove createdAt if not needed
                //     delete item.bidWantedId; // Remove bidWantedId if not needed
                //     return item;
                // });

                let filteredList = this.bidWantedSwapCusipBuyList.filter(
                    item => this.swapResultBuy.some(
                        buyItem => buyItem.cusip === item.cusip && buyItem.quantity === item.quantity
                    )
                );
                postData.bidWantedSwapCusipBuyList = filteredList.map(item => {
                    // const { createdAt, bidWantedId, ...rest } = item;
                    delete item.createdAt; // Remove createdAt if not needed
                    delete item.bidWantedId; // Remove bidWantedId if not needed
                    return item;
                });
            this.$http
            .post(
                config.baseUrlAutoBidder + "/bidwanted/swap-save",
                postData,
                auth
            )
            .then(response => {
                console.log("Swap history saved successfully:", response.data);
            })
            .catch(error => {
                console.error("Error saving swap history:", error);
            }); 
        },
        addCusip() {
            if(this.cusip.length != 9){
                this.$alert("Enter 9 digit characters long CUSIP","","error");
                return
            }

              const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/cusip/isExist?cusip=" + this.cusip.trim(),
                auth
              )
              .then(response => {
                   if(response.data === "NOTEXISTS"){
                        this.$alert("CUSIP does not exist.","","error");
                        this.cusip = '';
                        return;
                    }else{
                         const data = {
                            cusip: this.cusip?.trim() || '',
                            price: this.price,
                            quantity: this.quantity
                        };

                        if (data.cusip && data.price && data.quantity) {
                            this.bidWantedSwapCusipBuyList.push(data);
                            this.cusip = '';
                            this.price = '';
                            this.quantity = '';
                            this.setSwapHistoryToLocalStorage("savelocal");
                        } else {
                            // Optionally, show validation error here
                            this.$alert("Fill required fileds.","","error");
                        }

                    }
              })

           
        },
        getOrganizationSetting(){
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/organization/bid-settings?type=OFFER",
                auth
              )
              .then(response => {
                this.settlementDate = response.data.settlementDate;
              })
        },
    },
    mounted(){
        this.getOrganizationSetting();
        const storageKey = authService.getUser().id + 'swapHistory';
        const storedData = localStorage.getItem(storageKey);
        if (storedData) {
            try {
                // Parse the stored JSON data
                this.swapHistoryFromLocalStorage = JSON.parse(storedData); //get item aginst bidwnated id
                // Filter the data to include only items with the current bidWantedId
                const currentBidWantedId = this.selectedBidWanteds.map(bid => bid.id). join('-');
                this.bidWantedSwapCusipBuyList = this.swapHistoryFromLocalStorage.filter(item => item.bidWantedId === currentBidWantedId);
            } catch (error) {
                console.error("Error parsing stored swap history:", error);
                this.bidWantedSwapCusipBuyList = [];
            }
        }
    }
};
</script>
<style scoped>


    button.btn-danger {
        min-width: 0 !important;
    }
    .cusip-parent {
        display: flex;
        flex-wrap: wrap;
    }
    .cusip-child {
        padding: 9px;
        min-width: 130px;
    }
    .cusip-child span {
        font-size: 12px !important;
        color: #525f7f ;
        font-weight: 400;
    }
    .cusip-child h5 {
        color: #414a4c;
        font-size: 10.4px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 600;
    }

    .swap-summary-cards {
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
    }
    .summary-card {
        flex: 1 1 220px;
        min-width: 220px;
        padding: 16px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.07);
    }
    .summary-card-green {
        background-color: #e0f7e9;
        color: #28a745;
    }
    .summary-card-blue {
        background-color: #e3f2fd;
        color: #007bff;
    }
    .summary-card-primary {
        background-color: #e8f0fe;
        color: #007bff;
    }
    .summary-card-orange {
        background-color: #fff3e0;
        color: #ff9800;
    }
    .summary-label {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 8px;
    }
    .summary-value-green, .summary-value-blue, .summary-value-primary, .summary-value-orange {
        font-size: 18px;
        font-weight: 600;
    }

      .account-header {
      display: flex;
      gap: 40px;
      margin-bottom: 10px;
    }
    .account-header .name {
      font-weight: 700;
      font-size: 13px;
      color: #1f3864;
    }
    .account-header .id {
      font-weight: 700;
      font-size: 13px;
      color: #1f3864;
    }
      /* ── Section label ── */
    .section-label {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        color: var(--gray-400);
        margin-bottom: 10px;
    }
    
  /* ── Bid cards ── */
  .bid-cards-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
  }
  .bid-card {
    background: #fff;
    border: 1.5px solid #e2e8f0;
    border-radius: 8px;    
    padding: 12px 16px;
    min-width: 200px;
    flex: 1 1 200px;
    max-width: 240px;
    box-shadow: 0 1px 4px rgba(26,58,92,0.10);
    transition: box-shadow .18s, border-color .18s;
  }
  .bid-card:hover { box-shadow: 0 4px 18px rgba(26,58,92,0.13); border-color: #2196f3; }
  .bid-card-top {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .bc-cusip {
    font-weight: 700; font-size: 13px; color: #1a3a5c;
    background: #e3f2fd;
    border-radius: 4px;
    padding: 2px 7px;
  }
  .bc-qty {
    font-weight: 600; font-size: 12px; color: #28a745;
    background: #e6f9ed;
    border-radius: 4px;
    padding: 2px 7px;
  }
  .bc-price {
    font-weight: 700; font-size: 13px; color: #ff9800;
    background: #fff8ee;
    border-radius: 4px;
    padding: 2px 7px;
  }
  .bid-card input.spread-input {
    width: 100%;
    border: 1px solid #dde3ed;
    border-radius: 5px;
    padding: 5px 9px;
    font-size: 12px;
    color: #263044;
    background: #f8f9fa;
    outline: none;
    transition: border-color .15s;
  }
  .bid-card input.spread-input:focus { border-color: #2196f3; background: #fff; }
  .empty-col{
    /* background-color: transparent !important;
    border: none !important; */
  }




</style>
